export default {
  computed: {
    company: function () {
      return this.$store.state.company.COMPANY;
    },
    companyCanOfferFinance: function () {
      return this.$store.state.company.COMPANY && this.$store.state.company.COMPANY.country.iso_code === 'gb';
    }
  }
}
